import { Button, Card, Icon } from '@upside/flux-ui';

import { faCheckDouble } from '@fortawesome/pro-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

export function Success() {
  const { t: translate } = useTranslation(['login', 'resetPassword']);
  const { newUser } = useLocation().state as { newUser: boolean };

  return (
    <Card className="relative flex w-full max-w-md flex-col gap-6 rounded-xl p-8 shadow-md">
      <div className="flex w-full flex-col gap-4">
        <Icon className="self-center" icon={faCheckDouble} size="2xl" />
        <h1 className="text-center text-2xl font-medium text-foreground">
          {newUser
            ? translate('resetPassword:newUserSuccessMessage')
            : translate('resetPassword:successMessage')}
        </h1>
      </div>

      <Button className="w-full items-center justify-center" size="lg" asChild>
        <Link to="/login" role="link">
          <Button.Label>{translate('login:login')}</Button.Label>
        </Link>
      </Button>
    </Card>
  );
}
